"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _DatePickerDropdownSt = require("./DatePickerDropdown.st.css");

var _ChevronDown = _interopRequireDefault(require("wix-ui-icons-common/ChevronDown"));

var _DropdownBase = _interopRequireDefault(require("../../DropdownBase"));

var _TextButton = _interopRequireDefault(require("../../TextButton"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var DropdownPicker = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(DropdownPicker, _React$Component);

  var _super = _createSuper(DropdownPicker);

  function DropdownPicker() {
    var _this;

    (0, _classCallCheck2["default"])(this, DropdownPicker);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "state", {
      open: false
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_onSelect", function (data) {
      var onChange = _this.props.onChange;

      _this.setState({
        open: false
      }, function () {
        if (typeof onChange === 'function') onChange(data);
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_toggle", function () {
      _this.setState({
        open: !_this.state.open
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_onKeyDown", function (e, delegateKeyDown) {
      var eventWasHandled = delegateKeyDown(e);
      var open = _this.state.open; // We'll open the list when pressing the ArrowDown key

      if (!eventWasHandled && e.key === 'ArrowDown') {
        _this._open();

        e.preventDefault();
        return;
      } // close on Escape


      if (e.key === 'Escape') {
        _this._close();

        e.preventDefault();
      } // prevent TextButton onClick event


      if (open && (e.key === 'Enter' || e.key === 'Spacebar' || e.key === ' ')) {
        e.preventDefault();
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_close", function () {
      _this.setState({
        open: false
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_open", function () {
      _this.setState({
        open: true
      });
    });
    return _this;
  }

  (0, _createClass2["default"])(DropdownPicker, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          className = _this$props.className,
          caption = _this$props.caption,
          options = _this$props.options,
          dataHook = _this$props.dataHook,
          selectedId = _this$props.selectedId,
          ariaLabel = _this$props.ariaLabel,
          ariaLabelledBy = _this$props.ariaLabelledBy;
      var open = this.state.open;
      var finalAriaLabel = ariaLabel ? "".concat(ariaLabel, " ").concat(caption) : undefined;
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _DatePickerDropdownSt.st)(_DatePickerDropdownSt.classes.root, className)
      }, /*#__PURE__*/_react["default"].createElement(_DropdownBase["default"], {
        "data-hook": dataHook,
        className: _DatePickerDropdownSt.classes.dropdown,
        options: options,
        onClickOutside: this._close,
        dynamicWidth: true,
        minWidth: 120,
        selectedId: selectedId,
        onSelect: this._onSelect,
        focusOnSelectedOption: true,
        open: open
      }, function (_ref) {
        var delegateKeyDown = _ref.delegateKeyDown;
        return /*#__PURE__*/_react["default"].createElement(_TextButton["default"], {
          className: _DatePickerDropdownSt.classes.caption,
          skin: "dark",
          size: "small",
          suffixIcon: /*#__PURE__*/_react["default"].createElement(_ChevronDown["default"], null),
          onClick: _this2._toggle,
          dataHook: "".concat(dataHook, "-button"),
          onKeyDown: function onKeyDown(e) {
            return _this2._onKeyDown(e, delegateKeyDown);
          },
          ariaLabel: finalAriaLabel,
          ariaLabelledBy: ariaLabelledBy,
          ariaHaspopup: "listbox",
          ariaExpanded: open
        }, caption);
      }));
    }
  }]);
  return DropdownPicker;
}(_react["default"].Component);

exports["default"] = DropdownPicker;
(0, _defineProperty2["default"])(DropdownPicker, "propTypes", {
  dataHook: _propTypes["default"].string,
  className: _propTypes["default"].string,
  caption: _propTypes["default"].node,
  options: _propTypes["default"].array,
  onChange: _propTypes["default"].func,
  selectedId: _propTypes["default"].number,
  ariaLabel: _propTypes["default"].string,
  ariaLabelledBy: _propTypes["default"].string
});